export const tr = {
    'new-package': 'Yeni paket'
};
